import { __awaiter, __generator } from '../../../node_modules/tslib/tslib.es6.js';
import { styled, useMediaQuery, Snackbar, Alert } from '@mui/material';
import React, { useState } from 'react';
import brandclub_colors from '../../../colors/brandclubColors.js';
import { AppImage } from '../../../Components/AppImage/index.js';
import { getImageAssetUrl } from '../../../utils/assetUtils.js';
import { DIALOG_SCREEN_SIZE } from '../../../utils/constants/Constants.js';

var Container = styled('div')(function (_a) {
    var _b;
    var _c, _d, _e, _f, _g, _h, _j, _k;
    var theme = _a.theme;
    return ({
        display: 'flex',
        justifyContent: 'center',
        gap: 16,
        '.platform': {
            borderRadius: (_c = theme.globalButtonRadius) !== null && _c !== void 0 ? _c : 999,
            marginTop: 10,
            width: '100%',
            maxWidth: 335,
            fontSize: 16,
            fontWeight: 600,
            height: 50,
            display: 'flex',
            justifyContent: 'center',
            // gap: 8,
            alignItems: 'center',
            border: "none !important",
            transition: "background-color 0.3s ease-in-out",
            backgroundColor: (_f = (_e = (_d = theme.componentStyleOverrides) === null || _d === void 0 ? void 0 : _d.shareDialogButton) === null || _e === void 0 ? void 0 : _e.secondary) !== null && _f !== void 0 ? _f : theme.palette.primary.main,
        },
        'button.platform': {
            ':hover': {
                cursor: 'pointer',
            },
        },
        'div.platform-title': (_b = {
                fontFamily: 'Poppins',
                color: (_j = (_h = (_g = theme.componentStyleOverrides) === null || _g === void 0 ? void 0 : _g.shareDialogButton) === null || _h === void 0 ? void 0 : _h.primary) !== null && _j !== void 0 ? _j : (_k = theme.palette) === null || _k === void 0 ? void 0 : _k.getContrastText(theme.palette.primary.main),
                fontSize: 16,
                fontWeight: 600
            },
            _b["@media (max-width: ".concat(DIALOG_SCREEN_SIZE, "px)")] = {
                fontSize: 14,
            },
            _b),
        '.link-copied-snackbar': {
            '.MuiPaper-root': {
                fontSize: 16,
                backgroundColor: brandclub_colors.white,
                borderRadius: 12,
                boxShadow: '0 0 5px 0 rgba(0, 0, 0, 0.16)',
                paddingTop: 0,
                paddingBottom: 0,
            },
        },
    });
});
var SharePage = function (_a) {
    var url = _a.url, onShareLinkCopied = _a.onShareLinkCopied;
    var _b = useState(false), snackbarOpen = _b[0], setSnackbarOpen = _b[1];
    var _c = useState('Copy Link'), copyText = _c[0], setCopyText = _c[1];
    var desktopView = useMediaQuery("(min-width:".concat(DIALOG_SCREEN_SIZE, "px)"));
    var handleCopyLink = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    navigator.clipboard.writeText(url);
                    setCopyText('Link copied!');
                    if (!onShareLinkCopied) return [3 /*break*/, 2];
                    return [4 /*yield*/, onShareLinkCopied()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(Container, null,
        React.createElement("button", { className: "platform", onClick: handleCopyLink },
            React.createElement("div", { className: "platform-title" }, copyText)),
        React.createElement(Snackbar, { open: snackbarOpen, autoHideDuration: 3000, anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, sx: {
                boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
                borderRadius: '7px',
                overflow: 'hidden',
                position: desktopView ? 'absolute' : 'fixed',
                bottom: "".concat(desktopView ? '1.5' : '1', "% !important"),
                backgroundColor: brandclub_colors.white,
            }, onClose: function () { return setSnackbarOpen(false); } },
            React.createElement(Alert, { severity: "success", icon: React.createElement(AppImage, { src: getImageAssetUrl('icon_success_tick.webp'), alt: "icon-success-tick", style: { maxWidth: '20px' } }), sx: function (theme) { return ({
                    backgroundColor: brandclub_colors.white,
                    boxShadow: 'none',
                    color: theme.palette.primary.main,
                    fontSize: 12,
                    fontWeight: 600,
                }); } }, "Link copied"))));
};

export { SharePage };
//# sourceMappingURL=SharePage.js.map
